import { FilterList } from '@/modules/product/api/productList';

import { ActiveFilterList } from './types';

export const formatActiveFilterList = (
	filterList: FilterList,
	filters: Record<string, unknown>,
	currency: string
): ActiveFilterList => {
	const temp = filterList.filter((filter) => {
		if (!filters[filter.slug]) {
			return false;
		}

		return { ...filter };
	});

	return temp.map((filter) => {
		switch (filter.filterType) {
			case 'color':
				return {
					...filter,
					selectedValue: filters[filter.slug] as string[],
				};
			case 'checkbox':
				return {
					...filter,
					selectedValue: (filters[filter.slug] as string[]).map(
						(value: string) => `${value}${filter.unit !== null ? ` ${filter.unit}` : ''}`
					),
				};
			case 'range':
				const rangeFilter = filters[filter.slug] as { from: string; to: string };

				return {
					...filter,
					selectedValue: [
						`${Number(rangeFilter.from) / 100} ${currency}`,
						`${Number(rangeFilter.to) / 100} ${currency}`,
					],
				};
			case 'discount':
				return {
					...filter,
					selectedValue: (filters[filter.slug] as string[]).map((value: string) => value),
				};
		}
	}) as ActiveFilterList;
};

export const formatSidebarFilterList = (
	filterList: FilterList,
	filters: Record<string, unknown>,
	currency: string
): ActiveFilterList => {
	return filterList.map((filter) => {
		if (!filters[filter.slug]) {
			return {
				...filter,
				selectedValue: [],
			};
		}

		switch (filter.filterType) {
			case 'color':
				return {
					...filter,
					selectedValue: filters[filter.slug] as string[],
				};
			case 'checkbox':
				return {
					...filter,
					selectedValue: (filters[filter.slug] as string[]).map(
						(value: string) => `${value}${filter.unit !== null ? ` ${filter.unit}` : ''}`
					),
				};
			case 'range':
				const rangeFilter = filters[filter.slug] as { from: string; to: string };

				return {
					...filter,
					selectedValue: [
						`${Number(rangeFilter.from) / 100} ${currency}`,
						`${Number(rangeFilter.to) / 100} ${currency}`,
					],
				};
			case 'discount':
				return {
					...filter,
					selectedValue: (filters[filter.slug] as string[]).map((value: string) => value),
				};
		}
	}) as ActiveFilterList;
};

export const resetSidebarFilterList = (filterList: FilterList): ActiveFilterList => {
	return filterList.map((filter) => ({ ...filter, selectedValue: [] }));
};

export function formatFiltersBeforeSend(filters: ActiveFilterList): Record<string, unknown> {
	const newFilters: Record<string, unknown> = {};

	filters.forEach((filter) => {
		if (filter.selectedValue.length < 1) {
			return;
		}

		switch (filter.filterType) {
			case 'checkbox':
				newFilters[filter.slug] =
					filter.unit === null
						? filter.selectedValue
						: filter.selectedValue.map((value) => value.replace(` ${filter.unit}`, ''));
				break;
			case 'color':
			case 'discount':
				newFilters[filter.slug] = filter.selectedValue;
				break;
			case 'range':
				newFilters[filter.slug] = {
					from: (Number(filter.selectedValue[0].split(' ')[0]) * 100).toString(),
					to: (Number(filter.selectedValue[1].split(' ')[0]) * 100).toString(),
				};
				break;
		}
	});

	return newFilters;
}
